module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-bd"
  }, [_c('navbar'), _vm._v(" "), _c('div', {
    staticClass: "g-container"
  }, [_c('sidebar'), _vm._v(" "), _c('div', {
    staticClass: "g-main"
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-043065ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/frame.vue
// module id = 149
// module chunks = 2